// extracted by mini-css-extract-plugin
export var adjacentSlide = "_tj-9";
export var arrowButtonContainer = "_tj-5";
export var arrowButtonIcon = "_tj-6";
export var carouselArrowButton = "_tj-2";
export var carouselElementContainer = "_tj-1";
export var currentSlide = "_tj-8";
export var left = "_tj-3";
export var otherSlide = "_tj-a";
export var productCarouselContainer = "_tj-0";
export var right = "_tj-4";
export var sliderOverflow = "_tj-7";